import { filterObjectToExcludeNull } from '../../helper/objectHelpers';
import { getUsers } from '../users/usersSelectors';
import { fetchUser } from '../users/usersThunks/fetchUser';
import { getMemberByChannelIdAndUserId } from './membersSelectors';
import { channelMemberFetched, channelMemberRemoved, memberUpdated } from './membersSlice';

export const updateMember =
  ({ member }) =>
  async (dispatch) => {
    const memberExcludeNull = filterObjectToExcludeNull(member);
    dispatch(memberUpdated({ member: memberExcludeNull }));
  };

export const removeMember =
  ({ member }) =>
  async (dispatch) => {
    const { channelId } = member;
    dispatch(channelMemberRemoved({ channelId, member }));
  };

export const handleMemberJoined =
  ({ member }) =>
  async (dispatch, getState) => {
    const { channelId } = member;
    dispatch(channelMemberFetched({ channelId, member }));
    const users = getUsers(getState());
    const newId = member.userId;
    if (!users[newId]) {
      await dispatch(fetchUser({ id: newId }));
    }
  };

const typingTimeouts = {};

export const typingStarted =
  ({ channelId, userId }) =>
  async (dispatch, getState) => {
    const member = getMemberByChannelIdAndUserId(channelId, userId)(getState());

    if (!member) {
      return;
    }

    // Clear any existing timeout for this member if the typing event arrives again
    if (typingTimeouts[member.id]) {
      clearTimeout(typingTimeouts[member.id]);
    }

    // Set member to isTyping: true
    dispatch(updateMember({ member: { id: member.id, isTyping: true } }));

    // Start a new timeout to set isTyping to false after x seconds
    typingTimeouts[member.id] = setTimeout(() => {
      dispatch(updateMember({ member: { id: member.id, isTyping: false } }));
      // Clean up the timeout after it has executed
      delete typingTimeouts[member.id];
    }, 6000);
  };
